module.exports = __webpack_public_path__ + "static/media/practice-compliance-icon.ee838248.svg";